import { useEffect, useState, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Etapas from '../../components/NovaDemanda/Etapas';
import { Container, Footer, Header } from './styles';
import SelecionaTipoDemanda from '../../components/NovaDemanda/SelecionaTipoDemanda';
import ButtonDefault from '../../components/form/ButtonDefault';
import StepServico from '../../components/NovaDemanda/StepServico';
import { IDadosServico } from '../../components/NovaDemanda/StepServico/types';
import StepPartes from '../../components/NovaDemanda/StepPartes';
import DadosProfissional from '../../components/NovaDemanda/DadosProfissional';
import DadosFinal, { DadosFinalValores } from '../../components/NovaDemanda/DadosFinal';
import { comum } from '../../styles/Themes/light';
import { Oval } from 'react-loader-spinner';
import { IParteProcesso } from '../../components/NovaDemanda/StepPartes/types';
import api from '../../services/api';
import DemandaCriada from '../../components/NovaDemanda/DemandaCriada';
import toast, { Toaster } from 'react-hot-toast';
import LogoLegalOps from '../../components/LogoLegalOps';
import { useAuth } from '../../contexts/UserContext';
import { MAPEAMENTO_TITULO_SERVICO } from '../../utils/servicoMapper';
import { getFusoHorarioPorIdComarca, getFusoHorarioPorEstado } from '../../utility/timezoneUtils';

export default function FormularioProposta() {


    const { user } = useAuth();
    const history = useHistory();
    const location = useLocation<{ state?: { name?: string; proposal?: any } }>();
    const [titulo, setTitulo] = useState<string>('');
    const [tipo, setTipo] = useState<string>('');
    const [idServico, setIdServico] = useState<number | null>(null);
    
    const getInitialStep = () => {
        const stateData = (location?.state as any)?.state || (location?.state as any);
        return (stateData?.name === 'Reuse' && stateData?.proposal) ? 1 : 0;
    };
    
    const [step, setStep] = useState<number>(getInitialStep());
    const [comarca, setComarca] = useState<string>('');
    const [validando, setValidando] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [profissional, setProfissional] = useState<number>(0);
    const [dadosServico, setDadosServico] = useState<IDadosServico | null>(null);
    const [dadosFinal, setDadosFinal] = useState<DadosFinalValores | null>(null);
    const [partesProcesso, setPartesProcesso] = useState<IParteProcesso[]>([]);
    const [partesRepresentadas, setPartesRepresentadas] = useState<string[]>([]);
    const [idProposta, setIdProposta] = useState<number>(0);
    const [isUploadingFiles, setIsUploadingFiles] = useState<boolean>(false);
    const [idPropostaOriginal, setIdPropostaOriginal] = useState<number | null>(null);

    function parseIdServico(): number | undefined {
        if (tipo === 'Audiência') {
            const tituloNorm = titulo === 'Audiências' ? 'Outras Audiências' : titulo;
            if (dadosServico?.audiencia?.modalidade === 'presencial') {
                switch (tituloNorm) {
                    case 'Audiência Cível': return 1;
                    case 'Audiência Penal': return 3;
                    case 'Audiência Trabalhista': return 2;
                    case 'Outras Audiências': return 4;
                }
            } else {
                switch (tituloNorm) {
                    case 'Audiência Cível': return 17;
                    case 'Audiência Penal': return 19;
                    case 'Audiência Trabalhista': return 18;
                    case 'Outras Audiências': return 20;
                }
            }
        }

        const tituloNorm = titulo === 'Localização de veículo' ? 'Localização de Veículo' : titulo;
        switch (tituloNorm) {
            case 'Acompanhamento de atos oficiais': return 5;
            case 'Comparecimento em cartório': return 6;
            case 'Confirmação de endereço': return undefined;
            case 'Cópia integral': return 8;
            case 'Cópia parcial': return 9;
            case 'Despacho': return 10;
            case 'Emissão de guia': return undefined;
            case 'Retirada de ofício e alvará': return 11;
            case 'Petições': return 22;
            case 'Outras Diligências': return 12;
            case 'Penal': return undefined;
            case 'Diligência': return undefined;
            case 'Acautelamento': return 13;
            case 'Protocolo eletrônico': return 14;
            case 'Protocolo físico': return 15;
            case 'Protocolo postal': return 16;
            case 'Outro serviço': return 21;
            case 'Localização de Veículo': return 23;
            default:
                return undefined;
        }
    }


    function iniciarNovaDemanda() {
        setTitulo('');
        setTipo('');
        setIdServico(null);
        setStep(0);
        setComarca('');
        setValidando(false);
        setLoading(false);
        setProfissional(0);
        setDadosServico(null);
        setDadosFinal(null);
        setPartesProcesso([]);
        setPartesRepresentadas([]);
        setIdProposta(0);
        history.replace('/Nova-Demanda');
    }

    async function enviarProposta() {
        setLoading(true);

        let idServicoResolvido: number | undefined = idServico ?? parseIdServico();
        if (idServicoResolvido == null && titulo) {
            const tituloParaApi = titulo === 'Audiências' ? 'Outras Audiências' : titulo;
            const alternativas: string[] = [tituloParaApi];
            if (tituloParaApi === 'Baixa Complexidade') alternativas.push('Baixa complexidade');
            try {
                const servicoEndpoint = user?.profile === 'Solicitante' ? 'servico-publico' : 'servico';
                const catMap: Record<string, number> = { Audiência: 1, Diligência: 2, Protocolo: 3, Outros: 4, Petição: 5 };
                const catId = catMap[tipo];
                for (const t of alternativas) {
                    const url = catId != null
                        ? `${servicoEndpoint}?titulo=${encodeURIComponent(t)}&id_categoria_de_servico=${catId}`
                        : `${servicoEndpoint}?titulo=${encodeURIComponent(t)}`;
                    const res = await api.get(url);
                    const lista = Array.isArray(res.data?.result) ? res.data.result : [];
                    const primeiro = lista[0];
                    if (primeiro?.id_servico != null) {
                        idServicoResolvido = Number(primeiro.id_servico);
                        break;
                    }
                }
                if (idServicoResolvido == null && catId != null) {
                    const resAll = await api.get(`${servicoEndpoint}?id_categoria_de_servico=${catId}`);
                    const lista = Array.isArray(resAll.data?.result) ? resAll.data.result : [];
                    const porTitulo = lista.find((s: any) =>
                        String(s.titulo || '').toLowerCase() === tituloParaApi.toLowerCase()
                    );
                    if (porTitulo?.id_servico != null) idServicoResolvido = Number(porTitulo.id_servico);
                }
            } catch {
                idServicoResolvido = undefined;
            }
        }

        if (idServicoResolvido == null) {
            toast.error('Não foi possível identificar o serviço selecionado. Tente novamente.');
            setLoading(false);
            return;
        }

        const dados: any = {
            "id_usuario": profissional || undefined,
            "id_servico": idServicoResolvido,
            "id_comarca": dadosServico?.dadosBasicos.id_comarca,
            "arquivos": dadosFinal?.arquivos,
            "numero_processo": dadosServico?.dadosBasicos.numero_processo,
            ...(user.profile !== 'Solicitante' && { "prazo_aceite": dadosFinal?.prazo_aceite }),
            "prazo_para_conclusao": dadosFinal?.prazo_para_conclusao,
            "dias_uteis_para_conclusao": "",
            "orientacoes": dadosFinal?.orientacoes,
            "tipo_audiencia": dadosServico?.audiencia?.tipo_audiencia,
            "natureza": dadosServico?.dadosBasicos.natureza,
            // Preserve the inserted time (local time) instead of converting to UTC
            "data": dadosServico?.dadosBasicos.data
                ? `${dadosServico.dadosBasicos.data.getFullYear()}-${String(dadosServico.dadosBasicos.data.getMonth() + 1).padStart(2, '0')}-${String(dadosServico.dadosBasicos.data.getDate()).padStart(2, '0')}T${String(dadosServico.dadosBasicos.data.getHours()).padStart(2, '0')}:${String(dadosServico.dadosBasicos.data.getMinutes()).padStart(2, '0')}:${String(dadosServico.dadosBasicos.data.getSeconds()).padStart(2, '0')}`
                : undefined,
            'data_tz': dadosServico?.dadosBasicos.data_tz,
            "profissional_necessario": dadosServico?.audiencia?.profissional_necessario,
            "modalidade": dadosServico?.audiencia?.modalidade,
            "endereco_virtual": dadosServico?.audiencia?.endereco_virtual,
            "rua": dadosServico?.endereco.rua,
            "bairro": dadosServico?.endereco.bairro,
            "cep": dadosServico?.endereco.cep,
            "numero": dadosServico?.endereco.numero,
            "complemento": dadosServico?.endereco.complemento,
            "valor_profissional": dadosServico?.dadosBasicos.valor_profissional,
            "partes_processo": partesProcesso,
            "partes_representadas": partesRepresentadas
        };

        // Adiciona valor_cliente se existir (comum a todos os tipos de vínculo quando preenchido)
        if (dadosServico?.dadosBasicos.valor_cliente !== undefined) {
            dados.valor_cliente = dadosServico?.dadosBasicos.valor_cliente;
        }

        if (dadosServico?.dadosBasicos.tipo_parte === 'cliente') {
            dados.nome_cliente = dadosServico?.dadosBasicos.nome_cliente;
            dados.codigo_cliente = dadosServico?.dadosBasicos.codigo_cliente;
        } else if (dadosServico?.dadosBasicos.tipo_parte === 'solicitante') {
            dados.id_escritorio_solicitante = dadosServico?.dadosBasicos.id_escritorio_solicitante;
        }

        if (idPropostaOriginal) {
            dados.id_proposta_original = idPropostaOriginal;
        }


        const rota = user?.profile === 'Solicitante' ? '/proposta/solicitante' : '/proposta';
        api.post(rota, dados)
        .then((response) => {
            setLoading(false);
            if(response.data.status === 'error') {
                toast.error('Erro ao criar proposta');
            } else {
                setIdProposta(response.data.result);
            }
        })
        .catch((error) => {
            toast.error('Erro ao criar proposta');
            setLoading(false);
        })
        
    }

    const setDadosPartes = useCallback((partesProcesso: IParteProcesso[], partesRepresentadas: string[]) => {
        setPartesProcesso(partesProcesso);
        setPartesRepresentadas(partesRepresentadas);
    }, []);


    const [initialDadosServico, setInitialDadosServico] = useState<IDadosServico | undefined>(undefined);
    const [initialPartesProcesso, setInitialPartesProcesso] = useState<IParteProcesso[] | undefined>(undefined);
    const [initialPartesRepresentadas, setInitialPartesRepresentadas] = useState<string[] | undefined>(undefined);
    const [initialDadosFinal, setInitialDadosFinal] = useState<DadosFinalValores | undefined>(undefined);

    useEffect(() => {
        const processarDuplicacao = async () => {
            const stateData = (location?.state as any)?.state || (location?.state as any);
            if (stateData?.name !== 'Reuse' || !stateData?.proposal) {
                setInitialDadosServico(undefined);
                setInitialPartesProcesso(undefined);
                setInitialPartesRepresentadas(undefined);
                setInitialDadosFinal(undefined);
                return;
            }

            const proposal = stateData.proposal;
            const descCat = (proposal.descricao_categoria_servico || '').toLowerCase().trim();
            const tipoMap: Record<string, string> = {
                'audiências': 'Audiência', 'audiencia': 'Audiência', 'audiencias': 'Audiência',
                'diligências': 'Diligência', 'diligencia': 'Diligência', 'diligencias': 'Diligência',
                'petição': 'Petição', 'petições': 'Petição', 'peticoes': 'Petição', 'peticao': 'Petição',
                'protocolos': 'Protocolo', 'protocolo': 'Protocolo',
                'outros': 'Outros', 'outro': 'Outros'
            };
            const tipoNovo = tipoMap[descCat] || 'Diligência';
            let tituloNovo = proposal.titulo_servico || '';

            if (tipoNovo === 'Audiência' && tituloNovo && MAPEAMENTO_TITULO_SERVICO[tituloNovo]) {
                tituloNovo = MAPEAMENTO_TITULO_SERVICO[tituloNovo];
            }

            setTipo(tipoNovo);
            setTitulo(tituloNovo);

            if (proposal.id_servico != null && proposal.id_servico !== '') {
                setIdServico(Number(proposal.id_servico));
            }

            const idOrig = proposal.id_proposta_original ?? stateData.idPropostaOriginal;
            if (idOrig != null && idOrig !== '') {
                setIdPropostaOriginal(Number(idOrig));
            }

            if (proposal.uf_comarca && proposal.cidade_comarca) {
                const comarcaFormatada = `${proposal.uf_comarca.trim()} - ${proposal.cidade_comarca.trim()}`;
                setComarca(comarcaFormatada);
            } else if (proposal.id_comarca) {
                try {
                    const response = await api.get(`comarca/${proposal.id_comarca}`);
                    if (response.data.status === 'success' && response.data.result) {
                        const comarcaData = response.data.result;
                        const comarcaFormatada = `${comarcaData.uf?.trim() || ''} - ${comarcaData.cidade?.trim() || ''}`;
                        if (comarcaFormatada !== ' - ') {
                            setComarca(comarcaFormatada);
                        }
                    }
                } catch (error) {
                    console.error('Erro ao buscar comarca por ID:', error);
                }
            }

            let fusoHorarioComarca = 'BRT';
            if (proposal.id_comarca) {
                fusoHorarioComarca = await getFusoHorarioPorIdComarca(proposal.id_comarca);
            } else if (proposal.uf_comarca) {
                fusoHorarioComarca = getFusoHorarioPorEstado(proposal.uf_comarca);
            }

            const dadosServicoPreenchidos: IDadosServico = {
                dadosBasicos: {
                    id_comarca: proposal.id_comarca || null,
                    estado: proposal.uf_comarca || '',
                    numero_processo: proposal.numero_processo || '',
                    natureza: proposal.natureza || 'Judicial',
                    nome_cliente: proposal.nome_cliente || '',
                    valor_cliente: proposal.valor_cliente || undefined,
                    codigo_cliente: proposal.codigo_cliente || '',
                    valor_profissional: proposal.valor_profissional || undefined,
                    data: undefined,
                    data_tz: fusoHorarioComarca,
                    tipo_parte: 'cliente'
                },
                endereco: {
                    rua: proposal.rua || '',
                    bairro: proposal.bairro || '',
                    cep: proposal.cep || '',
                    numero: proposal.numero || '',
                    complemento: proposal.complemento || ''
                },
                audiencia: proposal.descricao_categoria_servico === 'Audiências' ? {
                    tipo_audiencia: proposal.tipo_audiencia || '',
                    profissional_necessario: proposal.profissional_necessario || '',
                    modalidade: ['online', 'Virtual'].includes(proposal.modalidade) 
                        ? 'Virtual' 
                        : (['presencial', 'Presencial'].includes(proposal.modalidade) ? 'presencial' : (proposal.modalidade || '')),
                    endereco_virtual: proposal.endereco_virtual || ''
                } : undefined,
                avulsos: {}
            };

            setInitialDadosServico(dadosServicoPreenchidos);
            setDadosServico(dadosServicoPreenchidos);

            if (proposal.partes_processo && Array.isArray(proposal.partes_processo)) {
                setInitialPartesProcesso(proposal.partes_processo);
                setPartesProcesso(proposal.partes_processo);
            }

            if (proposal.partes_representadas && Array.isArray(proposal.partes_representadas)) {
                setInitialPartesRepresentadas(proposal.partes_representadas);
                setPartesRepresentadas(proposal.partes_representadas);
            }

            const arquivosDuplicacao = (proposal.arquivos || []).map((arquivo: any) => ({
                nome: arquivo.caminho?.split('/').pop() || 'arquivo',
                tamanhoBytes: 0,
                arquivo_final: arquivo.arquivo_final || 'não',
                caminho: arquivo.caminho,
                id_proposta_arquivo_original: arquivo.id_proposta_arquivo_original
            }));

            const dadosFinalPreenchidos: DadosFinalValores = {
                prazo_aceite: null,
                prazo_para_conclusao: null,
                orientacoes: proposal.orientacoes || '',
                arquivos: arquivosDuplicacao
            };

            setInitialDadosFinal(dadosFinalPreenchidos);
            setDadosFinal(dadosFinalPreenchidos);
        };

        processarDuplicacao();
    }, [location]);

    useEffect(() => {
        const stateData = (location?.state as any)?.state || (location?.state as any);
        if (stateData?.name === 'Reuse' && stateData?.proposal) {
            return;
        }
        
        if (tipo && step === 0) {
            setStep(1);
        } else if (!tipo && step !== 0) {
            setStep(0);
        }
    }, [tipo, location, step]);

    useEffect(() => {
        if(step === 0) {
            setTitulo('');
            setTipo('');
        }
        if(user?.profile === 'Solicitante' && step === 3) {
            setStep(4);
        }
        if(step === 5) {
            enviarProposta();
        }
    }, [step, user?.profile]);
    



    return (
        <Container>
            {
                !idProposta &&
                <>
            <Toaster 
                position="top-center"
                toastOptions={{
                    duration: 3000,
                    style: {
                        background: 'var(--cffffff)',
                        color: 'var(--c3e4b52)',
                        padding: '16px',
                    },
                    success: {
                        duration: 3000,
                        style: {
                            background: 'var(--cffffff)',
                            color: 'var(--c3e4b52)',
                            border: '2px solid #0FC758',
                            padding: '16px',
                        },
                        iconTheme: {
                            primary: 'var(--c0fc758)',
                            secondary: 'var(--cffffff)',
                        },
                    },
                    error: {
                        duration: 3000,
                        style: {
                            background: 'var(--cffffff)',
                            color: 'var(--c3e4b52)',
                            border: '2px solid #E52940',
                            padding: '16px',
                        },
                        iconTheme: {
                            primary: 'var(--ce52940)',
                            secondary: 'var(--cffffff)',
                        },
                    },
                }}
            />

            <Header>
            <div className="logo"><LogoLegalOps alt="Logo EasyJur LegalOps" /></div>

             {
                step > 0 && titulo && tipo && 
                <Etapas activePage={step} />
             }
             {
                step === 0 && (!titulo || !tipo) && 
                <h1>Selecione o tipo de demanda</h1>
             }
            </Header>


            {
                (() => {
                    const stateData = (location?.state as any)?.state || (location?.state as any);
                    const isDuplicacao = stateData?.name === 'Reuse' && stateData?.proposal;
                    return step === 0 && (!titulo || !tipo) && !isDuplicacao;
                })() && 
                <SelecionaTipoDemanda setTitulo={setTitulo} setTipo={setTipo} />
            }

            {
                (() => {
                    const stateData = (location?.state as any)?.state || (location?.state as any);
                    const isDuplicacao = stateData?.name === 'Reuse' && stateData?.proposal;
                    return step === 0 && (!titulo || !tipo) && !isDuplicacao;
                })() &&
                <Footer>
                    <div className='btn-acoes'>
                        <ButtonDefault
                            className='cancel'
                            onClick={() => {
                                const stateData = (location?.state as any)?.state || (location?.state as any);
                                const idPropostaOriginalState = stateData?.idPropostaOriginal;
                                
                                if (idPropostaOriginalState) {
                                    history.push(`/demandas/${idPropostaOriginalState}/principal`);
                                } else if (window.history.length > 1) {
                                    history.goBack();
                                } else {
                                    history.push('/demandas');
                                }
                            }}
                        >
                            Cancelar
                        </ButtonDefault>
                    </div>
                </Footer>
            }

            {step !== 5 &&
                titulo && tipo && step !== 5 &&
                <Footer>
                    <div className='btn-acoes'>
                        <ButtonDefault 
                        className='cancel' 
                        onClick={() => {
                            if (step === 1) {
                                const stateData = (location?.state as any)?.state || (location?.state as any);
                                const idPropostaOriginalState = stateData?.idPropostaOriginal;
                                
                                if (idPropostaOriginalState) {
                                    history.push(`/demandas/${idPropostaOriginalState}/principal`);
                                } else if (window.history.length > 1) {
                                    history.goBack();
                                } else {
                                    history.push('/demandas');
                                }
                            } else {
                                if(user?.profile === 'Solicitante' && step === 4) {
                                    setStep(2);
                                } else {
                                    setStep(step - 1);
                                }
                            }
                        }}
                        
                        >{step === 1 ? 'Cancelar' : 'Voltar'}
                    </ButtonDefault>
                        <ButtonDefault 
                            className='continue' 
                            onClick={() => setValidando(true)}
                            disabled={isUploadingFiles}
                        >
                            {isUploadingFiles ? 'Enviando arquivos...' : 'Continuar'}
                        </ButtonDefault>
                    </div>
                </Footer>
            }

            <div className='content'>   
                {tipo && titulo && (
                    <StepServico 
                        step={1} 
                        currentStep={step} 
                        setCurrentStep={setStep}
                        validando={validando}
                        setValidando={setValidando}
                        setComarca={setComarca}
                        tipoDemanda={tipo} 
                        tituloFormulario={titulo} 
                        setDadosServico={setDadosServico}
                        initialDadosServico={initialDadosServico}
                    />
                )}
                {tipo && titulo && (
                    <>
                        <StepPartes
                            step={2}
                            currentStep={step}
                            setCurrentStep={setStep}
                            setPartes={setDadosPartes}
                            validando={validando}
                            setValidando={setValidando}
                            initialPartesProcesso={initialPartesProcesso}
                            initialPartesRepresentadas={initialPartesRepresentadas}
                        />
                        {
                            user.profile !== 'Solicitante' &&
                            <DadosProfissional
                                step={3}
                                currentStep={step}
                                setCurrentStep={setStep}
                                validando={validando}
                                setValidando={setValidando}
                                setProfissional={setProfissional}
                                comarca={comarca}
                                dadosServico={dadosServico}
                                tipoDemanda={tipo}
                                tituloDemanda={titulo}
                                idServicoSelecionado={idServico}
                            />
                        }
                        <DadosFinal
                            step={4}
                            currentStep={step}
                            setCurrentStep={setStep}
                            validando={validando}
                            setValidando={setValidando}
                            setDadosFinal={setDadosFinal}
                            fusoSelecionado={dadosServico?.dadosBasicos.data_tz}
                            prazoFatal={dadosServico?.dadosBasicos.data}
                            onUploadingChange={setIsUploadingFiles}
                            initialDadosFinal={initialDadosFinal}
                            userProfile={user.profile}
                        />
                    </>
                )}

                {
                    loading && step === 5 &&
                    <div className='loaderc'>
                    <Oval
                        height={150}
                        width={150}
                        color={comum.colors.primaryRed400}
                        visible={true}
                        ariaLabel='oval-loading'
                        secondaryColor={comum.colors.primaryRed300}
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                        wrapperStyle={{}}
                        wrapperClass="loader"
                        />
                    </div>
                }
            </div>
            </>
            }
            {
                idProposta > 0 &&
                <DemandaCriada id_proposta={idProposta} id_usuario={profissional} onNovaDemanda={iniciarNovaDemanda} />
            }

        </Container>
    )
}